export const SubAbas = [
  // { label: 'Aquisições', rota: '/daf/proaq/aquisicoes' },
  { label: 'Processos Licitatórios', rota: '/daf/proaq/processos' },
  // { label: 'ARPs', rota: '/daf/proaq/arps' },
  // { label: 'Contratos', rota: '/daf/proaq/contratos' },
  // { label: 'ACTs', rota: '/daf/proaq/acts' },
  // { label: 'TEDs', rota: '/daf/proaq/teds' },
  // { label: 'Org. Internacionais', rota: '/daf/proaq/orginters' },
  // { label: 'Empenhos Orçamentários', rota: '/daf/proaq/empenhos' },
];

export const SubAbasProaqId = (fichaId: string) => [
  {
    label: 'Dados gerais',
    rota: `/daf/proaq/processos/${fichaId}/dadosgerais`,
  },
  {
    label: 'Destaques',
    rota: `/daf/proaq/processos/${fichaId}/destaques`,
  },
];

export const SubAbasProaq = [
  {
    label: 'Dados gerais',
    rota: `/daf/proaq/processos/dadosgerais`,
  },
];
